<span class="text-success" *ngIf="params.data.ExpenseState.Code === 'VERIF'">
    <nb-icon size="2x" icon="fa-eye"></nb-icon>
</span>
<span class="text-warning" *ngIf="params.data.ExpenseState.Code === 'DONE'">
    <nb-icon size="2x" icon="fa-eye-slash"></nb-icon>
</span>
